import { useCallback, useRef } from 'react';
import { ConfigProvider } from 'antd';
import { ModuleSlider } from '../../common/map';
import { DataProvider } from './contexts/DataContext';
import { SelectionProvider } from './contexts/SelectionContext';
import { MapProvider } from './contexts/MapContext';
import { SankeyProvider } from './contexts/SankeyContext';
import { DisplayModeProvider } from './contexts/DisplayModeContext';
import { theme } from './config/theme';
import MapPage from './pages/MapPage';
import { SankeyView } from './components/Sankey';

import './styles/variables.css';
import './styles/base.css';
import './styles/leaflet-dark.css';
import './styles/app.css';
import './AnalysisPage.css';

function Analysis() {
  const moduleRef = useRef(null);
  // Popups render inside the module so the scoped Analysis styles reach them.
  const getPopupContainer = useCallback(() => moduleRef.current || document.body, []);

  return (
    <>
      <section className="analysis-module" aria-label="Analisi OD" ref={moduleRef}>
        <ConfigProvider theme={theme} getPopupContainer={getPopupContainer}>
          <DataProvider>
            <SelectionProvider>
              <DisplayModeProvider>
                <MapProvider>
                  <SankeyProvider>
                    <div className="App">
                      <MapPage />
                      <SankeyView />
                    </div>
                  </SankeyProvider>
                </MapProvider>
              </DisplayModeProvider>
            </SelectionProvider>
          </DataProvider>
        </ConfigProvider>
      </section>

      <ModuleSlider
        showNavbarControls={false}
        setShowNavbarControls={() => {}}
        showSimfixAreas={false}
        setShowSimfixAreas={() => {}}
        showPredictMode={false}
        setShowPredictMode={() => {}}
        showTlGreenWave={false}
        setShowTlGreenWave={() => {}}
        showAssignx={false}
        setShowAssignx={() => {}}
      />
    </>
  );
}

export default Analysis;
